/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createViewerRelationshipHook } from '../../core/factories/createViewerRelationshipHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetHiddenMarketCheckRow } from '../openapi-types.gen.js';
import { type useGetHiddenMarketCheckArgs, useGetHiddenMarketCheckSpec } from '../specs/hidden-markets.spec.gen.js';

export type { GetHiddenMarketCheckRow } from '../openapi-types.gen.js';
export type { useGetHiddenMarketCheckArgs } from '../specs/hidden-markets.spec.gen.js';


export const useGetHiddenMarketCheck = createViewerRelationshipHook(useGetHiddenMarketCheckSpec);


/**
 * Hover/intent prefetch companion for `useGetHiddenMarketCheck`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetHiddenMarketCheck();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetHiddenMarketCheck = createPrefetchHook(useGetHiddenMarketCheckSpec);
